import { ChangeDetectionStrategy, Component, input, type InputSignal } from '@angular/core';

@Component({
  selector: 'ui-page-shell',
  imports: [],
  templateUrl: './ui-page-shell.component.html',
  styleUrl: './ui-page-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiPageShellComponent {
  public readonly ariaLabel: InputSignal<string> = input<string>('Page');
  public readonly padded: InputSignal<boolean> = input<boolean>(true);
  public readonly hasTabbar: InputSignal<boolean> = input<boolean>(true);
}
